const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.01,
};

const state = {
  components: [],
  elements: {},
};

function cacheState() {
  state.components = {
    mediaEls: document.querySelectorAll('[data-hub-header-media]'),
  };
}

function initVideo() {
  state.components?.mediaEls?.forEach((mediaEl) => {
    const videoEl = mediaEl.querySelector("video");

    if (!videoEl) return;

    let wasPlaying = true;
    let wasMuted = true;

    const playPauseBtn = mediaEl.querySelector('[data-type="video"]');
    const muteUnmuteBtn = mediaEl.querySelector('[data-type="audio"]');

    playPauseBtn.addEventListener("click", (e) => {
      if (playPauseBtn.dataset.state === "playing") {
        videoEl.pause();
        playPauseBtn.dataset.state = "paused";
      } else {
        videoEl.play();
        playPauseBtn.dataset.state = "playing";
      }
    });

    muteUnmuteBtn.addEventListener("click", (e) => {
      if (muteUnmuteBtn.dataset.state === "muted") {
        videoEl.muted = false;
        muteUnmuteBtn.dataset.state = "unmuted";
      } else {
        videoEl.muted = true;
        muteUnmuteBtn.dataset.state = "muted";
      }
    });

    const observer = new IntersectionObserver((e) => {
      if (!e[0].isIntersecting) {
        wasPlaying = !videoEl.paused;
        wasMuted = videoEl.muted;

        videoEl.pause();
        playPauseBtn.dataset.state = "paused";
        return;
      }

      videoEl.muted = wasMuted;
      if (!wasPlaying) return;

      videoEl.play();
      playPauseBtn.dataset.state = "playing";
    }, options);
    observer.observe(videoEl);
  });
}

const init = () => {
  cacheState();
  initVideo();
};

export default init;
